import { useEffect, useState } from 'react';
import { Channel } from '@bo-components/alerts/Channel';
import { ChannelTree } from '@bo-components/alerts/ChannelTree';
import type { FormattedChannel } from '@library/types/alerts';
import { useChannels } from '@bo-hooks/alerts/useChannels';
import { useSentrySetDashBoardTag } from '@bo-hooks/sentry/useSentrySetDashBoardTag';

export const AlertsDashboard = () => {
  useSentrySetDashBoardTag({ dashboardName: 'Alerts' });

  const { allChannelsData, readChannel } = useChannels({});

  const [channels, setChannels] = useState<FormattedChannel[] | undefined>(
    undefined
  );

  const [isUserSubscribedCheck, setIsUserSubscribedCheck] = useState(false);

  const [page, setPage] = useState(1);

  const [selectedChannel, setSelectedChannel] = useState<
    FormattedChannel | undefined
  >(undefined);

  useEffect(() => {
    if (selectedChannel) {
      setIsUserSubscribedCheck(selectedChannel.isUserSubscribed);
    }
  }, [selectedChannel]);

  useEffect(() => {
    if (allChannelsData) {
      setChannels(allChannelsData);
    }
    setSelectedChannel({
      description: '',
      displayName: 'Notifications',
      id: 0,
      isUserSubscribed: true,
      isChannelUnread: false
    });
  }, [allChannelsData]);

  return (
    <div className="flex h-full py-0 pl-3">
      <ChannelTree
        channels={channels}
        setChannels={setChannels}
        setPage={setPage}
        selectedChannel={selectedChannel}
        setSelectedChannel={setSelectedChannel}
        readChannel={readChannel}
      />
      {selectedChannel && (
        <Channel
          page={page}
          setPage={setPage}
          setChannels={setChannels}
          selectedChannel={selectedChannel}
          setSelectedChannel={setSelectedChannel}
          isUserSubscribedCheck={isUserSubscribedCheck}
          setIsUserSubscribedCheck={setIsUserSubscribedCheck}
        />
      )}
    </div>
  );
};
